import LanguageContext, {
  LanguageContextProvider,
  Languages,
} from "./LanguageContext";

export default LanguageContext;
export { LanguageContextProvider, Languages };
